import { environment } from '../../environments/environment';

export const workflowApiConfig = environment.workflowApi;
